import { AxiosResponse } from 'axios';
import { iliData } from '../apis';
import { Ili } from '../types';

export const getIliData = async (iliId: string): Promise<AxiosResponse<Ili>> =>
  iliData.get<Ili>(`ili/${iliId}`);
